import { mockMember } from '@gonfalon/members/mocks/mockMember';
import { id, key, name, oneOf, pastDate } from '@gonfalon/mocks/common';
import { createMockResourceBuilder } from '@gonfalon/mocks/createMockResourceBuilder';
import type { Member, schemas } from '@gonfalon/openapi/types';

const environmentConfigs: Record<string, { name: string; color: string }> = {
  production: { name: 'Production', color: 'F5A623' },
  staging: { name: 'Staging', color: '5C7CFA' },
  development: { name: 'Development', color: '45B882' },
};

const projectConfigs: Record<string, { name: string; key: string }> = {
  ios: { name: 'IOS project', key: 'ios-proj' },
  android: { name: 'Android project', key: 'android-proj' },
};

export const mockMetricDataSource = createMockResourceBuilder(
  (): schemas['MetricDataSourceRep'] => {
    const envKey = oneOf(['production', 'staging', 'development']);
    const envConfig = environmentConfigs[envKey];
    const projKey = oneOf(['ios', 'android']);
    const projConfig = projectConfigs[projKey];
    return {
      _id: id(),
      tags: [],
      _creationDate: pastDate(),
      key: key(),
      name: name(),
      integrationKey: oneOf(['snowflake', 'databricks', 'redshift', 'bigquery']),
      environmentKey: envKey,
      _lastModified: pastDate(),
      maintainer: mockMember().create(),
      _links: {},
      _environmentSummary: {
        name: envConfig.name,
        color: envConfig.color,
      },
      _projectSummary: {
        name: projConfig.name,
        key: projConfig.key,
      },
    };
  },
  {
    withKey: (dataSourceKey: string) => (draft) => {
      draft.key = dataSourceKey;
    },
    withName: (dataSourceName: string) => (draft) => {
      draft.name = dataSourceName;
    },
    withIntegrationKey: (integrationKey: string) => (draft) => {
      draft.integrationKey = integrationKey;
    },
    withEnvironmentKey: (environmentKey: string) => (draft) => {
      draft.environmentKey = environmentKey;
    },
    withMaintainer: (maintainer: Member) => (draft) => {
      draft.maintainer = maintainer;
    },
    withoutMaintainer: () => (draft) => {
      draft.maintainer = undefined;
    },
    withLastModified: (lastModified: number) => (draft) => {
      draft._lastModified = lastModified;
    },
  },
);
